module.exports = __webpack_public_path__ + "img/entry2.0b4f03c7.jpg";